(function(){
  const drawer = document.getElementById('mvs-cart');
  if(!drawer) return;

  const overlay     = document.getElementById('mvs-cart-overlay');
  const itemsEl     = document.getElementById('mvs-cart-items');
  const subtotalEl  = document.getElementById('mvs-cart-subtotal');
  const closeBtn    = drawer.querySelector('.mvs-cart__close');
  const openBtns    = document.querySelectorAll('[data-open-cart]');
  const progress    = drawer.querySelector('.mvs-cart__progress');
  const progressFill= drawer.querySelector('.mvs-cart__progress-fill');
  const progressText= drawer.querySelector('.mvs-cart__progress-text');

  const fmt = new Intl.NumberFormat(undefined, {
    style:'currency',
    currency:(Shopify.currency && Shopify.currency.active) || 'USD'
  });

  function open(){
    drawer.classList.add('is-open');
    overlay?.removeAttribute('hidden');
    drawer.setAttribute('aria-hidden','false');
  }
  function close(){
    drawer.classList.remove('is-open');
    overlay?.setAttribute('hidden','');
    drawer.setAttribute('aria-hidden','true');
  }

  openBtns.forEach(b=>{
    b.addEventListener('click', e=>{
      e.preventDefault();
      open();
      refresh();
    });
  });
  closeBtn?.addEventListener('click', close);
  overlay?.addEventListener('click', close);
  document.addEventListener('keydown', e=>{ if(e.key==='Escape') close(); });

  async function getCart(){
    const r = await fetch('/cart.js', { credentials:'same-origin' });
    return r.json();
  }

  function renderLine(item){
    const img = item.image ? `<img class="mvs-item__img" src="${item.image}" alt="">` : '';
    return `<div class="mvs-item" data-key="${item.key}">
      ${img}
      <div>
        <p class="mvs-item__title">${item.product_title}</p>
        <div class="mvs-item__meta">${item.variant_title||''}</div>
        <div class="mvs-item__qty">
          <button class="mvs-item__btn" data-act="dec">–</button>
          <span aria-live="polite">${item.quantity}</span>
          <button class="mvs-item__btn" data-act="inc">+</button>
          <button class="mvs-item__btn" data-act="rm" title="Remove">×</button>
        </div>
      </div>
      <div class="mvs-item__price">${fmt.format(item.final_line_price/100)}</div>
    </div>`;
  }

  function bindLineEvents(){
    itemsEl?.querySelectorAll('.mvs-item').forEach(row=>{
      row.addEventListener('click', async (e)=>{
        const btn = e.target.closest('[data-act]'); if(!btn) return;
        const key = row.getAttribute('data-key');
        const act = btn.getAttribute('data-act');
        const qtyEl = row.querySelector('.mvs-item__qty span');
        let qty = parseInt(qtyEl.textContent,10);
        if(act==='inc') qty++;
        if(act==='dec') qty = Math.max(0, qty-1);
        if(act==='rm') qty = 0;
        await fetch('/cart/change.js', {
          method:'POST',
          headers:{'Content-Type':'application/json'},
          body:JSON.stringify({id:key, quantity:qty})
        });
        await refresh();
      });
    });
  }

  function updateCartCount(count){
    const badge = document.getElementById('mvs-cart-count');
    if(!badge) return;
    if(count > 0){
      badge.textContent = String(count);
      badge.classList.add('is-visible');
    } else {
      badge.textContent = '0';
      badge.classList.remove('is-visible');
    }
  }

  async function refresh(){
    const cart = await getCart();

    if(itemsEl){
      itemsEl.innerHTML = cart.items.map(renderLine).join('') || '<p style="padding:14px">Your cart is empty.</p>';
    }
    if(subtotalEl){
      const subtotal = (cart.items_subtotal_price ?? cart.total_price) / 100;
      subtotalEl.textContent = fmt.format(subtotal);
    }

    bindLineEvents();

    // Use subtotal (pre-shipping/taxes) for progress calculation
    const subtotalForProgress = (cart.items_subtotal_price ?? cart.total_price) / 100;
    updateProgress(subtotalForProgress);

    updateCartCount(cart.item_count);

    // announce update
    window.dispatchEvent(new CustomEvent('mvs:cart:updated', {
      detail:{ subtotal: subtotalForProgress, count: cart.item_count }
    }));
  }

  function updateProgress(subtotal){
    if(!progress) return;
    const threshold = Number(progress.dataset.threshold || 60);
    const pct = Math.max(0, Math.min(100, (subtotal/threshold)*100));
    if(progressFill) progressFill.style.width = `${pct}%`;

    const tpl = progress.getAttribute('data-label-template') || 'Add [remaining] for free shipping';
    const congrats = progress.getAttribute('data-congrats') || 'You’ve unlocked free shipping!';
    if(progressText){
      if(subtotal >= threshold){
        progressText.textContent = congrats;
      } else {
        const remaining = Math.max(0, threshold - subtotal);
        const money = fmt.format(remaining);
        progressText.textContent = tpl
          .replace('[remaining]', money)
          .replace('{{remaining}}', money)
          .replace('{remaining}', money);
      }
    }
  }

  // Intercept product adds -> open drawer & refresh
  document.addEventListener('submit', async (e)=>{
    const form = e.target;
    if(!(form instanceof HTMLFormElement)) return;
    if(!form.action || !form.action.includes('/cart/add')) return;

    if(form.__mvsSubmitting) return;
    form.__mvsSubmitting = true;
    e.preventDefault(); e.stopPropagation(); if(e.stopImmediatePropagation) e.stopImmediatePropagation();

    try{
      const data = new FormData(form);
      await fetch('/cart/add.js', { method:'POST', body:data, headers:{'X-Requested-With':'XMLHttpRequest'} });
      open();
      await refresh();
    } finally {
      form.__mvsSubmitting = false;
    }
  }, true);

  // Initial load: set count + progress
  document.addEventListener('DOMContentLoaded', refresh);
})();

// --- HARDENED progress updater (drop-in) ---
(function hardenProgress(){
  const wrapSel  = '#mvs-cart .mvs-cart__progress';
  const trackSel = '.mvs-cart__progress-track';
  const fillSel  = '.mvs-cart__progress-fill';
  const textSel  = '.mvs-cart__progress-text';

  const money = (n) => {
    const cents = Math.round(n * 100);
    try {
      return (window.Shopify?.formatMoney)
        ? Shopify.formatMoney(cents, Shopify.money_format)
        : `$${n.toFixed(2)}`;
    } catch(_) { return `$${n.toFixed(2)}`; }
  };

  async function computeAndApply(){
    const wrap  = document.querySelector(wrapSel);
    if(!wrap) return;
    const track = wrap.querySelector(trackSel);
    const fill  = wrap.querySelector(fillSel);
    const text  = wrap.querySelector(textSel);
    if(!track || !fill || !text) return;

    // make sure colors are obvious (even if CSS vars didn’t load)
    track.style.backgroundColor = '#FFFFFF';
    fill.style.backgroundColor  = '#90A99F';

    const threshold = Number(wrap.dataset.threshold || 60);
    const labelTpl  = wrap.dataset.labelTemplate || 'Add [remaining] for free shipping';
    const congrats  = wrap.dataset.congrats || 'You’ve unlocked free shipping!';

    // fetch cart
    const res  = await fetch('/cart.js', { credentials:'same-origin' });
    const cart = await res.json();
    const subtotal = ((cart.items_subtotal_price ?? cart.total_price) || 0) / 100;

    const pct = Math.max(0, Math.min(100, (subtotal / threshold) * 100));

    // force a paint, then set width (ensures you actually see it move)
    fill.style.width = '0%';
    requestAnimationFrame(() => { fill.style.width = pct + '%'; });

    const remaining = Math.max(0, threshold - subtotal);
    text.textContent = remaining > 0
      ? labelTpl.replace('[remaining]', money(remaining))
      : congrats;
  }

  // run on page load
  document.addEventListener('DOMContentLoaded', computeAndApply);

  // run when our main script announces a cart update
  window.addEventListener('mvs:cart:updated', computeAndApply);

  // run each time the drawer becomes visible (and a couple times after)
  const drawer = document.getElementById('mvs-cart');
  if (drawer) {
    new MutationObserver(() => {
      if (drawer.getAttribute('aria-hidden') === 'false') {
        computeAndApply();
        setTimeout(computeAndApply, 300);
        setTimeout(computeAndApply, 900);
      }
    }).observe(drawer, { attributes:true, attributeFilter:['aria-hidden'] });
  }

  // safety: after any /cart/add form submit
  document.body.addEventListener('submit', (e) => {
    if (e.target?.action?.includes('/cart/add')) {
      setTimeout(computeAndApply, 600);
    }
  });
})();
